import { cn } from '@/lib/utils';
import React from 'react';
import { useTestTileContext } from './context';
import TestItemToggle from './toggle-switch';

type ExclusionToggleProps = {
    // onToggle: (excluded: boolean) => void;
    label?: string;
    offLabel?: string;
    enableAlways?: boolean;
    className?: string;
}

const ExclusionToggle: React.FC<ExclusionToggleProps> = (
    {
        label = 'Include',
        offLabel = 'Include',
        enableAlways = false,
        className,
    }
) => {
    const { item, exclusionReason, exclusionToggleOperable } = useTestTileContext();
    // const isTestIncluded = exclusionReason === 'included';
    const isTestIncluded = item.switches?.include !== false;
    // const { item } = useTestTileContext()

    const isDisabled = !enableAlways && !exclusionToggleOperable;

    return (
        <div className={cn(className, isDisabled && 'opacity-50 pointer-events-none')}>
            <TestItemToggle
                label={label}
                offLabel={offLabel}
                switchType="include"
                // variant={exclusionReason}
                variant="included"
                disabled={isDisabled}
                item={item}
                value={isTestIncluded}
            />
        </div>
    );
};

export default ExclusionToggle;